import { FileText, Image } from 'lucide-react';
import Icon from '@/components/primitives/Icon.jsx';

/** What the person asked, with the files they attached. A request still being sent reads as such. */
const RequestBlock = ({ text, attachments, pending }) => {
  return (
    <div className="assistant-request" data-pending={pending ? 'true' : undefined}>
      <span className="assistant-request__who">You</span>
      {text && <p className="assistant-request__text">{text}</p>}
      {attachments.length > 0 && (
        <ul className="assistant-request__files" aria-label="Attached files">
          {attachments.map((attachment) => (
            <li key={attachment.attachmentId || attachment.filename} className="assistant-request__file">
              <Icon icon={attachment.mediaKind === 'image' ? Image : FileText} size="sm" />
              {attachment.filename || 'File'}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RequestBlock;
